/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon20Regular = forwardRef('ArrowDCornerLeftDownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 3.75A1.75 1.75 0 0 0 7.75 5.5v10.528l3.957-4.146a.75.75 0 1 1 1.085 1.036L8.629 17.28a2.25 2.25 0 0 1-3.256 0l-4.165-4.363a.75.75 0 1 1 1.086-1.036l3.957 4.146V5.5A3.25 3.25 0 0 1 9.5 2.25H18a.75.75 0 0 1 0 1.5H9.5Z" })));
});
